import { IBar, IPitch, TShowPitchesTaskData } from "../../../../../common/types";
import getScore from "./getScore";
import { INotationThis } from "./interfaces";

export const checkReady = function (this: INotationThis) {
    let submitable = true;
    const { currentNote, activeVoice } = this.state;
    const taskScore = this.state.taskScore!;
    const data =this.props.task.data as TShowPitchesTaskData;
    const { showPitches } = data;
    const maxVoice = [0, 1, 2, 3, 4, 5].filter(v => taskScore["bars" + (v || "")]).pop()!;
    outer: for (let v = 0; v <= maxVoice; v++) {
        if (showPitches && activeVoice !== v) continue;
        const bars = taskScore["bars" + (v || "")] as IBar[];
        for (let b = 0; b < bars.length; b++) {
            let bar = bars[b];
            if (bar === null) continue;
            for (let n = 0; n < bar.notes.length; n++) {
                let note = bar.notes[n];
                if (
                    showPitches &&
                    note.p &&
                    !note.r &&
                    (b > currentNote!.bar || (b === currentNote!.bar && n > currentNote!.note - 1))
                ) {
                    submitable = false;
                    break outer;
                }
                if (!note.r && !note.p) submitable = false;
            }
        }
    }
    if (showPitches && submitable) {
        if (activeVoice !== maxVoice) {
            let currentNote = {
                bar: 0,
                note: 0,
            };
            const bars = taskScore["bars" + (activeVoice + 1)];
            if (bars[0] === null) {
                currentNote = {
                    bar: 1,
                    note: 0,
                };
            }
            while (
                bars[currentNote.bar] &&
                bars[currentNote.bar].notes.length &&
                bars[currentNote.bar].notes[currentNote.note].r
            ) {
                currentNote.note++;
                if (bars[currentNote.bar].notes.length === currentNote.note) {
                    currentNote.bar++;
                    currentNote.note = 0;
                }
            }
            this.setState({ activeVoice: activeVoice + 1, currentNote });
        } else {
            this.submit!();
        }
    }
    if (!showPitches) {
        this.setState({ submitable });
    }
};

export const submit = function (this: INotationThis) {
    const { taskScore } = this.state;
    const incorrectNotes: number[][] = [[], [], [], [], [], []];
    const { task, plan } = this.props;
    const score = getScore(plan, task)!;
    let completed = true;

    const maxVoice = [0, 1, 2, 3, 4, 5].filter(v => taskScore!["bars" + (v || "")]).pop()!;
    for (let v = 0; v <= maxVoice; v++) {
        let totalNoteIndex = 0;
        const bars = taskScore!["bars" + (v || "")] as IBar[];
        for (let b = 0; b < bars.length; b++) {
            const bar = bars[b];
            if (bar === null) continue;
            for (let n = 0; n < bar.notes.length; n++) {
                const note = bar.notes[n];
                if (!note.r) {
                    const solutionPitch = note.p as IPitch;
                    const pitch = (score["bars" + (v || "")] as IBar[])[b].notes[n].p as IPitch;
                    if (
                        solutionPitch.s !== pitch.s ||
                        (solutionPitch.o || 0) !== (pitch.o || 0) ||
                        (solutionPitch.a || 0) !== (pitch.a || 0)
                    ) {
                        incorrectNotes[v].push(totalNoteIndex);
                        completed = false;
                    }
                }
                totalNoteIndex++;
            }
        }
    }
    if (completed) {
        if (this.props.completed) {
            this.props.completed(this.props.task.type);
        }
    } else {
        this.props.handleFailCount!();
    }

    this.setState({ incorrectNotes, submited: true, completed });
};

export const failedInput = function (this: INotationThis) {
    this.setState({ failedNote: true });
    this.props.handleFailCount!();
    this.failedNoteTimer = setTimeout(() => {
        this.setState({ failedNote: false });
    }, 2000);
};
